// DashboardLayout.js
import React, { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import * as Icons from 'lucide-react';

const DashboardLayout = ({ children, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const mainMenuItems = [
    { icon: 'LayoutDashboard', label: 'Dashboard', path: '/dashboard' },
    { icon: 'BookOpen', label: 'Blogs', path: '/dashboard/blogs' },
    { icon: 'Mic2', label: 'Speeches', path: '/dashboard/speeches' },
    { icon: 'Newspaper', label: 'News', path: '/dashboard/news' },
    { icon: 'FileText', label: 'Articles', path: '/dashboard/articles' },
    { icon: 'Calendar', label: 'Events', path: '/dashboard/events' },
    { icon: 'Users', label: 'Interviews', path: '/dashboard/interviews' },
    { icon: 'FolderKanban', label: 'Projects', path: '/dashboard/projects' },
    { icon: 'MessageSquare', label: 'SSCN Messages', path: '/dashboard/messages' },
    { icon: 'Coffee', label: 'OvenFresh', path: '/dashboard/ovenfresh' },
    { icon: 'Users', label: 'View Subscribers', path: '/dashboard/subscribers' },
    { icon: 'MessageCircle', label: 'View Comments', path: '/dashboard/comments' },
  ];

  const bottomMenuItems = [
    { 
      icon: 'RefreshCw', 
      label: 'Switch Portal', 
      path: '/marathi-dashboard',
      onClick: () => navigate('/marathi-dashboard')
    },
    { icon: 'LogOut', label: 'Logout', path: '#', onClick: onLogout },
  ];

  const handleNavigation = useCallback((item) => {
    try {
      if (item.onClick) {
        item.onClick();
      } else if (item.path) {
        navigate(item.path);
        console.log('Navigating to:', item.path);
      }
    } catch (error) {
      console.error('Navigation error:', error);
    }
  }, [navigate]);

  const isActivePath = useCallback((path) => {
    return location.pathname === path;
  }, [location]);

  const renderIcon = (iconName) => {
    const Icon = Icons[iconName];
    return Icon ? <Icon className="w-5 h-5" /> : null;
  };

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <div className="w-64 bg-sky-500 text-white shadow-lg flex flex-col">
        {/* Logo Area */}
        <div className="flex items-center gap-2 px-6 py-4 border-b border-sky-400">
          {renderIcon('LayoutDashboard')}
          <span className="text-lg font-semibold">RajendraShende.com</span>
        </div>

        {/* Main Menu */}
        <div className="px-4 py-2 flex-grow overflow-y-auto">
          <nav className="space-y-1">
            {mainMenuItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavigation(item)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm rounded-lg transition-colors duration-150 ${
                  isActivePath(item.path)
                    ? 'bg-sky-600'
                    : 'hover:bg-sky-600'
                }`}
              >
                {renderIcon(item.icon)}
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Divider */}
        <div className="px-6 py-4">
          <hr className="border-sky-400" />
        </div>

        {/* Bottom Menu */}
        <div className="px-4 pb-4">
          <nav className="space-y-1">
            {bottomMenuItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavigation(item)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-sm rounded-lg transition-colors duration-150 ${
                  isActivePath(item.path)
                    ? 'bg-sky-600'
                    : 'hover:bg-sky-600'
                }`}
              >
                {renderIcon(item.icon)}
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 overflow-auto">
        <div className="p-8">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;